import { IntlShape } from "react-intl";
import { IItems } from "../interface/CommonInterface";

export const convertListToItems = (
  objectList: IItems[],
  intl: IntlShape,
): IItems[] => {
  if (objectList?.length) {
    return objectList.map(({ id, label }) => {
      return { id, label: intl.formatMessage({ id: label }) };
    });
  }
  return [];
};
